type ModalCallback = (...args: any[]) => any;

const modalCallbacks = new Map<string, ModalCallback>();

export const registerModalCallback = (callback: ModalCallback): string => {
  const id = `modal-callback-${Date.now()}-${Math.random()
    .toString(36)
    .slice(2)}`;

  modalCallbacks.set(id, callback);

  return id;
};

export const runModalCallback = async (
  callbackId?: string,
  ...args: any[]
): Promise<void> => {
  if (!callbackId) {
    return;
  }

  const callback = modalCallbacks.get(callbackId);

  if (!callback) {
    return;
  }

  await callback(...args);
};

export const removeModalCallback = (callbackId?: string): void => {
  if (!callbackId) {
    return;
  }

  modalCallbacks.delete(callbackId);
};